import { createApp } from '@app/adapters/create-app'
import { getOverviewFilter } from '@app/adapters/silverfin'
import SfFlash from '@app/shared/vue/components/sf-flash'
import SFetch from '@app/utils/sfetch'
import { SfLog } from '@app/adapters/logger'

const setup = (doc) => {
  let warningMessageComponent

  const initializeWarningMessage = async () => {
    const warningElem = doc.querySelector(
      "[data-behaviour='checks-not-visible-in-workflow']"
    )

    if (!warningElem) {
      return
    }

    const { wrapperClasses, url } = warningElem.dataset

    try {
      const data = await SFetch.json(url)

      if (data.checksNotVisibleInWorkflow > 0) {
        const message = I18n.t('company_workflows.checks_not_visible', {
          count: data.checksNotVisibleInWorkflow,
        })

        warningMessageComponent = createApp(
          SfFlash,
          {
            message: message,
            type: 'alert',
            wrapperClasses: wrapperClasses,
          },
          {
            singletonId: 'checks-not-visible-in-workflow-warning',
          }
        )

        warningMessageComponent.mount(warningElem)
      }
    } catch {
      SfLog.warn(
        `Failed to fetch data for "checks not visible in workflow" in ${url}`
      )
    }
  }

  const destroyWarningMessage = () => {
    if (warningMessageComponent) {
      warningMessageComponent.unmount()
      warningMessageComponent = null
    }
  }

  const onFilterSelect = (e) => {
    const target = e.target.closest('[data-filter-status]')

    if (!target) return destroyWarningMessage()

    const { filterStatus } = target.dataset

    if (filterStatus === 'checks') {
      initializeWarningMessage()
    } else {
      destroyWarningMessage()
    }
  }

  const status = getOverviewFilter()

  if (status === 'checks') {
    initializeWarningMessage()
  }

  window.eventHub.$on('workflows-filter-reset', destroyWarningMessage)
  window.eventHub.$on('workflows-filter-unselected', destroyWarningMessage)
  window.eventHub.$on('workflows-filter-selected', onFilterSelect)

  document.addEventListener(
    'turbolinks:visit',
    () => {
      window.eventHub.$off('workflows-filter-reset', destroyWarningMessage)
      window.eventHub.$off('workflows-filter-unselected', destroyWarningMessage)
      window.eventHub.$off('workflows-filter-selected', onFilterSelect)
    },
    { once: true }
  )
}

onDomLoad(($dom) => {
  const doc = $dom[0]
  // only used in async-rendered ledger_table - only initialize this on render_async_load
  const onRenderAsync = () => setup(doc)

  document.addEventListener('render_async_load', onRenderAsync)

  document.addEventListener(
    'turbolinks:visit',
    () => {
      document.removeEventListener('render_async_load', onRenderAsync)
    },
    { once: true }
  )
})
